<template>
<el-card>
  <template v-slot:header>
    <div>
      <span class="mr-[40px]">邀请人员</span>
    </div>
  </template>
   <div class="mb-[10px] flex flex-row">
    <div class="flex-1 flex flex-row items-center">
      <span class="mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">查找人员</span>
      <el-input class="flex-1" placeholder="输入姓名、手机号、工号" maxlength="32" v-model="searchItem.staff" @keyup.enter.native="find()"></el-input>
    </div>
    <div class="flex-1 flex flex-row items-center">
      <span class="ml-[15px] mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">邀请方式</span>
      <el-select v-model="searchItem.mode" class="flex-1" placeholder="请选择邀请方式">
        <el-option class="text-600" key="" label="全部" value=""></el-option>
        <el-option key=1 label="系统录入" value=0></el-option>
        <el-option key=2 label="用户申请" value=1></el-option>
      </el-select>
    </div>
    <div class="flex-1 flex flex-row items-center">
      <span class="ml-[15px] mr-[10px] whitespace-nowrap overflow-hidden overflow-ellipsis">审核状态</span>
     <el-select v-model="searchItem.status" class="flex-1" placeholder="请选择审核状态">
        <el-option class="text-600" key='' label="全部" value=''></el-option>
        <el-option key=1 label="待确认" value=0></el-option>
        <el-option key=2 label="待审核" value=1></el-option>
        <el-option key=3 label="已加入" value=2></el-option>
        <el-option key=4 label="已驳回" value=3></el-option>
      </el-select>
    </div>
    <div class="flex flex-row ml-[20px]">
      <el-button type="primary" @click="find()">查找</el-button>
      <el-button @click="reset()">清除条件</el-button>
    </div>
  </div>

  <div class="h-[10px] bg-[#f2f3f5]"></div>
    <div class="flex flex-row pt-[5px] pb-[10px]">
    <el-button type="primary">添加成员</el-button>
    <el-button @click="pass()" :disabled="selection.length === 0">批量通过</el-button>
    <el-button @click="reject()" :disabled="selection.length === 0">批量驳回</el-button>
    <el-button @click="urge()" :disabled="selection.length === 0">批量催办</el-button>
    <el-button @click="remove()" :disabled="selection.length === 0">批量删除</el-button>
  </div>
  <el-table ref="multipleTable" :data="users" border @selection-change="handleSelectionChange">
    <el-table-column type="selection" width="55"></el-table-column>
    <el-table-column prop="index" label="序号" width="50" fixed></el-table-column>
    <el-table-column prop="name" label="姓名/昵称" width="150">
      <template v-slot="{ row }">
        <span>{{row.name}}</span><span v-if="row.nickname !== ''"> ({{row.nickname}})</span>
      </template>
    </el-table-column>
    <el-table-column prop="mobile" label="手机号" width="130">
      <template v-slot="{ row }">
        <span class="whitespace-nowrap overflow-hidden overflow-ellipsis">{{ row.mobile }}</span>
      </template>
    </el-table-column>
    <el-table-column prop="mode" label="邀请方式" width="100">
      <template v-slot="{ row }">
        <span v-if="row.mode === 0" >系统录入</span>
        <span v-else-if="row.mode === 1">用户申请</span>
      </template>
    </el-table-column>
    <el-table-column prop="accountStatus" label="账户状态" width="80">
      <template v-slot="{ row }">
        <span v-if="row.accountStatus === 0" class="text-[#F56C6C] font-bold">未实名</span>
        <span v-else-if="row.accountStatus === 1">已实名</span>
        <span v-else-if="row.accountStatus === 2" class="text-[#FF0000] font-bold">已冻结</span>
      </template>
    </el-table-column>
    <el-table-column prop="checkStatus" label="审核状态" width="80">
      <template v-slot="{ row }">
        <span v-if="row.checkStatus === 0" class="text-[#F56C6C] font-bold">待确认</span>
        <span v-else-if="row.checkStatus === 1" class="text-[#F56C6C] font-bold">待审核</span>
        <span v-else-if="row.checkStatus === 2">已加入</span>
        <span v-else-if="row.checkStatus === 3">已驳回</span>
      </template>
    </el-table-column>
    <el-table-column prop="departments" label="所属部门"></el-table-column>
    <el-table-column prop="roles" label="人员角色"></el-table-column>
    <el-table-column label="操作" width="80" fixed="right">
      <template v-slot="{row}">
        <el-button @click="urgeOne(row)" type="primary" size="mini">催办</el-button>
      </template>
    </el-table-column>
  </el-table>
  </el-card>

</template>

<script>
import { 
  fetchInvitations,
  deleteInvitation,
  passInvitation,
  rejectInvitation,
  urgeInvitation,
} 
from '@/api/api';

export default {
  name:"InvitationPage",
  data() {
    return {
      users: [],
      selection:[],
      searchItem: {
        staff: '',
        mode: '',
        status: '',
      },
      orgId: 1,
      orgName: '南京百市通数字科技有限公司',
    }
  },

  mounted() {
    this.get();
  },

  methods: {
    get() {
      let that = this;
      this.searchItem.staff = this.searchItem.staff.trim();
      let mode = -1;
      if (this.searchItem.mode !== "") {
        mode = this.searchItem.mode
      }
      let status = -1;
      if (this.searchItem.status !== "") {
        status = this.searchItem.status
      }

      fetchInvitations(this.searchItem.staff, mode, status, this.orgId).then(result => {
        try{
          that.users=[];
          let data = result.data.data;
          let count = data.total;
          for (let i=0; i<count; i++) {
            let item = {}
            item.index = i+1;
            item.id = data.users[i].id;
            item.nickname = data.users[i].nickname;
            item.name = data.users[i].name;
            item.mobile = data.users[i].mobile;
            item.mode = data.users[i].mode;
            item.accountStatus = data.users[i].account_status;
            item.checkStatus = data.users[i].check_status;
            that.users.push(item);
          }
        }catch(e) {
          console.log(e);
        }
      })
      .catch(error => {
        console.error("错误信息：", error);
      });
    },
    find() {
      this.get();
    },
    reset() {
      this.searchItem.staff = "";
      this.searchItem.mode = "";
      this.searchItem.status = "";
      this.get();
    },
    remove() {
      if (this.selection.length == 0) {
        this.$message.error("请选择后再批量删除");
        return;
      }
      this.$confirm("您确定要批量删除吗？", '批量删除邀请', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          let ids = "";
          this.selection.forEach(element => {
            ids += "," + element.id
          });
          deleteInvitation(ids, this.orgId).then(() => {
            this.$message({message: '批量删除成功',type: 'success'});
            this.get();
          }).catch( error => {
            this.$message.error(error);
          });
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },
    pass() {
      if (this.selection.length == 0) {
        this.$message.error("请选择后再批量通过");
        return;
      }

      this.$confirm("您确定要批量通过吗？", '批量通过邀请', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          let ids = "";
          this.selection.forEach(element => {
            ids += "," + element.id
          });

          const data = JSON.stringify({
            "ids": ids,
            "org_id" : this.orgId
          });
          passInvitation(data).then(() => {
            this.$message({message: '批量通过成功',type: 'success'});
            this.get();
          }).catch( error => {
            this.$message.error(error);
          });
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },
    reject() {
      if (this.selection.length == 0) {
        this.$message.error("请选择后再批量驳回");
        return;
      }

      this.$confirm("您确定要批量驳回吗？", '批量驳回邀请', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          let ids = "";
          this.selection.forEach(element => {
            ids += "," + element.id
          });

          const data = JSON.stringify({
            "ids": ids,
            "org_id" : this.orgId
          });
          rejectInvitation(data).then(() => {
            this.$message({message: '批量驳回成功',type: 'success'});
            this.get();
          }).catch( error => {
            this.$message.error(error);
          });
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },
    urge() {
      if (this.selection.length == 0) {
        this.$message.error("请选择后再批量催办");
        return;
      }

      this.$confirm("您确定要批量催办吗？", '批量催办邀请', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          let ids = "";
          this.selection.forEach(element => {
            ids += "," + element.id
          });

          const data = JSON.stringify({
            "ids": ids,
            "org_id" : this.orgId
          });
          urgeInvitation(data).then(() => {
            this.$message({message: '批量催办成功',type: 'success'});
            this.get();
          }).catch( error => {
            this.$message.error(error);
          });
        }).catch((err) => {
          if (err == "cancel") {  
            return
          }
          this.$message.error(err);
        })
    },
    urgeOne(invitation) {
      const data = JSON.stringify({
        "ids": "" + invitation.id,
        "org_id" : this.orgId
      });
      urgeInvitation(data).then(() => {
        this.$message({message: '催办成功',type: 'success'});
        this.get();
      }).catch( error => {
        this.$message.error(error);
      });
    },
    handleSelectionChange(val) {
      this.selection = val;
    }
  },
}
</script>